// extracted by mini-css-extract-plugin
export default {"root":"ProfileTabNav_root__0eFiR","tabsContainer":"ProfileTabNav_tabsContainer__RRocM","tab":"ProfileTabNav_tab__3bjdL"};